import api_url from "../../libary/axios-home";

export const registerCompany = async (formData) => {
  const { data } = await api_url.post(`register/admin`, {
    ...formData,
  });
  return data;
};
